export default __webpack_public_path__ + "static/1-34cd7efb7d57a916beebe862b2412639.png";